<template>
  <div
    class="wf-flex wf-flex-wrap wf-justify-between wf-w-full wf-py-2 wf-items-center"
  >
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Alignment:</span>
    <div class="wf-w-1/2">
      <select v-model="contentAlignment" class="wf-w-full">
        <option value="ICON_ROTATE_NONE">None</option>
        <option value="ICON_ROTATE_90">Rotate 90</option>
      </select>
    </div>
  </div>
</template>

<script>
  import MenuContentProperty from '../contracts/MenuContentProperty'
  export default MenuContentProperty.extend({
    computed: {
      contentAlignmentClasses() {},
      contentAlignment() {}
    }
  })
</script>
